<template>
  <div class="home-menu d-flex aling-items-center justify-content-around">
    <div v-if="isLoggedIn" class="home-menu-box master-box">
      <h3>マスタ情報</h3>
      <div class="master-menu-items">
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'CustomerList'}">顧客情報</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'BuildingTypeList'}">建物種別情報</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'BuildingList'}">建物情報</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'DeviceList'}">測定機器情報</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'MeasureTypeList'}">測定種別情報</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'RelativeHumidityMatrix'}">相対湿度マトリクス</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'MeasureStdList'}">空気環境測定基準値</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'UserList'}">ユーザ情報</router-link></div>
      </div>
    </div>

    <div class="home-menu-box all-rep-box">
      <h3>全測定報告書一覧</h3>
      <div>
        <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'MeasurementReportList'}">測定報告一覧</router-link>
      </div>
    </div>

    <div class="home-menu-box create-rep-box">
      <h3>測定報告書作成</h3>
      <div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'CustomerBuildingList'}">建物一覧</router-link></div>
        <!-- IES4一括取込はシステム管理者専用のため、権限がある場合だけ導線を出す -->
        <div class="item-block" v-if="canUseIes4Bulk"><router-link class="memu-item" :to="{ name: 'MeasurementReportIes4BulkImport'}">IES4一括取込</router-link></div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { ref } from 'vue';
import { canUseIes4BulkImport, currentRoleFromStoreOrLocalStorage } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('ホーム');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    // Vuex ストアの状態を算出プロパティとして使用
    const isLoggedIn = computed(() => store.state.isLoggedIn);
    const canUseIes4Bulk = computed(() => (
      isLoggedIn.value && canUseIes4BulkImport(currentRoleFromStoreOrLocalStorage(store.state.userRole))
    ));

    return {
      title,
      isLoggedIn,
      canUseIes4Bulk
    };
  }
};
</script>

<style scoped>
.home-menu {
  display: flex;
  justify-content: space-around;
  align-items: flex-start; /* これにより、アイテムが上揃えになる */
  width: 100%;
  /* height: calc(100% - 100px); */
  margin: 50px auto;
  padding: 20px;
  padding: 20px 20px 80px 20px;
}

.home-menu .home-menu-box {
  display: flex;
  flex-direction: column; /* 縦並びにする */
  justify-content: flex-start; /* コンテンツを上揃えにする */
  width: calc(33.333% - 40px); /* 3つのボックスが同じ行に収まるように調整 */
  height: 100%;
  margin: 20px; /* マージンでボックス同士の間隔を調整 */
  background-color: #ffffff; /* 明るい背景色 */
  border: 1px solid #cccccc; /* 軽い境界線 */
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: transform 0.3s ease;
  box-sizing: border-box; /* パディングとボーダーをwidthに含める */
}

.home-menu .home-menu-box:hover {
  transform: translateY(-10px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
}

.home-menu .home-menu-box h3 {
  color: #333; /* ダークグレーのテキスト色 */
  margin-bottom: 20px;
}

.home-menu .memu-item {
  display: block;
  background-color: #2f4e6d; /* プライマリーカラー */
  color: white;
  padding: 10px 8px;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s;
}

.home-menu .memu-item:hover {
  background-color: #667c97; /* ホバーエフェクト */
}
</style>
